import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const BellIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/bell"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M11.9999 2.40002C8.02346 2.40002 4.79991 5.62357 4.79991 9.60003C4.79991 11.864 4.25543 13.9981 3.29108 15.8812C3.16305 16.1312 3.15907 16.4266 3.28033 16.68C3.40158 16.9333 3.63417 17.1155 3.90918 17.1726C5.1904 17.4387 6.49413 17.6427 7.81706 17.7817C8.00988 19.9224 9.809 21.6 12 21.6C14.1909 21.6 15.99 19.9224 16.1828 17.7817C17.5057 17.6427 18.8095 17.4387 20.0906 17.1726C20.3657 17.1155 20.5982 16.9333 20.7195 16.68C20.8407 16.4266 20.8368 16.1312 20.7087 15.8812C19.7444 13.9981 19.1999 11.864 19.1999 9.60003C19.1999 5.62357 15.9764 2.40002 11.9999 2.40002ZM9.65911 17.932C10.4337 17.9771 11.2142 18 11.9999 18C12.7857 18 13.5662 17.9771 14.3408 17.932C14.0988 19.0015 13.1426 19.8 12 19.8C10.8573 19.8 9.90112 19.0015 9.65911 17.932Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default BellIcon;